export const BASE_API_URL = "https://highbound-api.jleclair.workers.dev";
export const AUTH_ERROR = "AUTHENTICATION ERROR";
